import React from 'react'
import styled from 'styled-components/macro'
import { Theme, Reset, ToastProvider } from '@resultadosdigitais/tangram-components'
import { withHostContext } from '@resultadosdigitais/front-hub/react'
import loginService from 'login-service'
import Login from 'components/Login'
import './base.css'

const StyledTheme = styled(Theme)`
  height: 100vh !important;
  min-height: 100vh !important;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  align-content: stretch;
`

function App({ csrf, firebase_config }) {
  const csrfToken = csrf.token
  const siteKey = firebase_config?.recaptcha?.site_key || {}
  loginService.configure({ csrfToken })

  return (
    <React.StrictMode>
      <StyledTheme value={Theme.kinds.lina}>
        <Reset />
        <ToastProvider>
          <Login siteKey={siteKey} />
        </ToastProvider>
      </StyledTheme>
    </React.StrictMode>
  )
}

export default withHostContext(App)
